import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { ON_CLOSE_MEATBALLS } from '../../../constants/custom-events';
import { IMAGES_ASSETS_URL } from '../../../constants/links';
import { Card } from '../../shared/card/card';
import { getLastModifiedDate } from '../../../utils/date';
import { MeatballsMenu, } from '../../shared/meatballs-menu/meatballs-menu';
import { CardType } from '../../../constants/payments';
import { pushErrorEvent } from '../../../utils/analytics';
import { CHANGES_SAVED_MSG, DELETED_PAYPAL_ACCOUNT_MSG, } from '../../../constants/response-success-messages';
import { ERR_UNABLE_TO_SAVE } from '../../../constants/response-error-messages';
import { usePayments } from '../../../hooks/use-payments';
import { getPaymentsErrorCode } from '../../../utils/payments';
import { useMeatballMenuActions } from '../../../hooks/use-meatball-payment-actions';
export const PaypalCard = ({ card, isB2B, index, onActionSuccess, onActionFailure, handlePaypalEdit, handlePaypalError, }) => {
    var _a, _b, _c, _d, _e;
    const { paypalCards } = usePayments();
    const currentPaypalCard = (_a = paypalCards === null || paypalCards === void 0 ? void 0 : paypalCards.response) === null || _a === void 0 ? void 0 : _a.find((payment) => payment.paymentId === card.paymentId);
    const { onEditPaypal, onViewPurchases, onEditPaypalNickName, openPaypalDeleteModal, } = useMeatballMenuActions();
    const handleCloseMeatBalls = () => {
        const closeMeatballsCustomEvent = new Event(ON_CLOSE_MEATBALLS);
        document.dispatchEvent(closeMeatballsCustomEvent);
    };
    const editPaypalOnApprove = (data) => {
        return handlePaypalEdit(data, currentPaypalCard).then(() => {
            handleCloseMeatBalls();
        });
    };
    const handleOpenEditNickNameModal = () => {
        const onSuccess = () => {
            onActionSuccess(card.paypalAccountId || '', CHANGES_SAVED_MSG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.paypalAccountId || '', ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('edit nickname paypal card', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onEditPaypalNickName(card, currentPaypalCard, onSuccess, onFailure);
    };
    const handleDeletePaypal = () => {
        const onSuccess = () => {
            onActionSuccess(card.paypalAccountId || '', DELETED_PAYPAL_ACCOUNT_MSG.message, index);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.paypalAccountId || '', ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('delete paypal card', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        openPaypalDeleteModal(card, onSuccess, onFailure);
    };
    const menuItems = [
        {
            value: 'Edit',
            isHidden: (!((_b = card.actions) === null || _b === void 0 ? void 0 : _b.edit) && isB2B) || !isB2B,
            action: () => null,
            payPalBtn: (React.createElement(PayPalButtons, { fundingSource: "paypal", createOrder: onEditPaypal, onApprove: editPaypalOnApprove, onError: () => {
                    handlePaypalError(card.paypalAccountId);
                    handleCloseMeatBalls();
                }, onCancel: () => {
                    handleCloseMeatBalls();
                }, style: {
                    height: 36,
                } })),
        },
        {
            value: 'View Purchases',
            isHidden: (!((_c = card.actions) === null || _c === void 0 ? void 0 : _c.viewPurchases) && isB2B) || !isB2B,
            action: () => {
                onViewPurchases(card, CardType.PAYPAL_ACCOUNT);
            },
        },
        {
            value: 'Add/Edit Nickname',
            isHidden: (!((_d = card.actions) === null || _d === void 0 ? void 0 : _d.edit) && isB2B) || !isB2B,
            action: handleOpenEditNickNameModal,
        },
        {
            value: 'Delete',
            isHidden: !((_e = card.actions) === null || _e === void 0 ? void 0 : _e.delete) && isB2B,
            action: handleDeletePaypal,
        },
    ];
    return (React.createElement(Card, { isDefault: false, isInactive: false, defaultLabel: "Default Payment Method" },
        React.createElement("div", { className: `sui-flex sui-justify-between sui-align-center ${card.cardNickName ? 'sui-mb-2' : 'sui-mb-3'}` },
            React.createElement("h3", { "data-testid": "nickname", className: "sui-font-display sui-text-3xl sui-mr-4 sui-truncate sui-text-primary" }, isB2B && card.cardNickName),
            React.createElement("div", null,
                React.createElement(MeatballsMenu, { label: "Payment", items: menuItems }))),
        React.createElement("div", { className: "sui-flex sui-mb-6 sui-items-center" },
            React.createElement("img", { alt: "paypal logo", width: 57, height: "100%", className: "sui-inline-block sui-mr-4", src: `${IMAGES_ASSETS_URL}/paypal-logo-v2.svg` }),
            React.createElement("div", { className: "sui-mr-4 sui-overflow-hidden" },
                React.createElement(Typography, { truncate: true, variant: "body-lg", color: "subtle" }, card.paypalAccountId))),
        card.addedBy && (React.createElement("div", { className: "sui-overflow-hidden" },
            React.createElement(Typography, { truncate: true, color: "subtle" },
                "Added by ",
                React.createElement("span", { "data-qm-mask": "" }, card.addedBy)))),
        card.lastModifiedDate && (React.createElement(Typography, { color: "subtle" },
            "Last edited ",
            getLastModifiedDate(card.lastModifiedDate)))));
};
PaypalCard.displayName = 'PaypalCard';
